export default __webpack_public_path__ + "static/media/6-color.0d111f60.svg";